import { ParkingTariffValidity } from './parking-tariff-validity';

declare global {
  interface Array<T> {
    getNonFallbackParkingTariffs(this: Array<ParkingTariffValidity>): ParkingTariffValidity[];
    getFallbackParkingTariffs(this: Array<ParkingTariffValidity>): ParkingTariffValidity[];
  }
}

Array.prototype.getNonFallbackParkingTariffs = function() {
  return this.filter(v => !v.isFallbackTariff);
};

Array.prototype.getFallbackParkingTariffs = function() {
  return this.filter(v => v.isFallbackTariff);
};

export{};
